import Configuration from '@/configuration'
import { UserManager, WebStorageStateStore } from 'oidc-client-ap'

export default class AuthService {
  constructor() {
    const settings = {
      authority: Configuration.value('authAuthority') + '/v2.0/.well-known/openid-configuration',
      client_id: Configuration.value('authClientID'),
      redirect_uri: `${window.location.origin}/signin-internal.html`,
      response_type: 'code',
      scope: 'api://f6cd66fc-325a-4e0d-acd4-f52e1ca579f6/moc_as_user',
      post_logout_redirect_uri: 'https://www.airproducts.com',
      automaticSilentRenew: true,
      silent_redirect_uri: `${window.location.origin}/signin-internal-silent.html`
    }

    localStorage.setItem('user_manager_internal', JSON.stringify(settings))
    settings.userStore = new WebStorageStateStore({ store: window.localStorage })
    this.userManager = new UserManager(settings)
  }

  getUser() {
    return this.userManager.getUser()
  }

  async getAccessToken() {
    let user = await this.userManager.getUser()
    if (!user || user.expired) {
      try {
        user = await this.userManager.signinSilent()
        if (!user || user.expired) {
          user = await this.login()
        }
      } catch (error) {
        console.log(error)
        user = await this.login()
      }
    }
    return user.access_token
  }

  async getIdToken() {
    let user = await this.userManager.getUser()
    if (!user || user.expired) {
      user = await this.userManager.signinSilent()
      if (!user || user.expired) {
        throw new Error('We failed to get the user id_token, contact support')
      }
    }
    return user.id_token
  }

  async getLoggedIn() {
    const user = await this.userManager.getUser()

    return user && !user.expired
  }

  login() {
    return this.userManager.signinPopup()
  }

  loginRedirect() {
    return this.userManager.signinRedirect()
  }

  logout() {
    return this.userManager.signoutRedirect()
  }
}
